// Module
var code = `<div class="footer-buttons">
	<!-- ko if: \$data.listView && \$data.listView().pageSize() <= 50 -->
	<div class="actions">
		<div class="pull-sm-left">
			<!-- ko if: \$data.listView && \$data.listView().totalCount() > 0 -->
			<div class="text-muted btn-group" data-bind="with: \$data.listView">
				Showing
				<strong><span data-bind="text: (pageIndex()*pageSize())+1"></span> to
					<span data-bind="text: ((totalCount() < pageSize() || (pageSize()*(pageIndex()+1)) > totalCount())?totalCount():(pageSize()*(pageIndex()+1)))"></span></strong>
				of <strong data-bind="text: totalCount"></strong>
			</div>
			<!-- /ko -->
		</div>
		<div class="pull-sm-right">
			<!-- ko if: \$data.listView -->
			<label class="btn-group text-muted" for="numberOfRows">Show rows:</label>
			<div class="btn-group">
				<div class="select">
					<select class="form-control" id="numberOfRows" data-bind="value: \$data.listView().pageSize, options: \$data.listView().pageSizes"></select>
				</div>
			</div>

			<!-- ko if: \$data.listView().pages().length > 1 -->
			<div class="paging btn-group" role="group">
				<button type="button" class="btn btn-secondary prev-page" data-bind="click: function(){ if(listView().isFirstPage()){ return; } listView().prevPage();  }, css:{ disabled: listView().isFirstPage }" aria-label="Go to previous list page">
					<i class="fa fa-angle-left"></i>
				</button>

				<!-- ko foreach: listView().pages() -->
				<button type="button" class="btn btn-secondary" data-bind="text: \$data, click: function(){ \$parent.listView().goToPage(\$data); }, attr:{ disabled: \$data == '...', 'aria-label': 'Go to page ' + \$data }, css:{ active: (\$parent.listView().pageIndex() + 1) == \$data }"></button>
				<!-- /ko -->

				<button type="button" class="btn btn-secondary next-page" data-bind="click: function(){ if(listView().isLastPage()){ return; } listView().nextPage(); }, css:{ disabled: listView().isLastPage }" aria-label="Go to next list page">
					<i class="fa fa-angle-right"></i>
				</button>
			</div>
			<!-- /ko -->
			<!-- /ko -->
		</div>
	</div>
	<!-- /ko -->
</div>
`;
// Exports
export default code;